import React, { FC } from 'react';
import useTranslations from '@hooks/useTranslations';

interface StockEnvironmentalDataProps {
    environmentalData: {
        power: {
            value: string;
            label: string;
        };
        consumptionCombined: {
            value: string;
            label: string;
        };
        co2Combined: {
            value: string;
            label: string;
        };
        electricRange: {
            value: string;
            label: string;
        };
    };
}

const StockEnvironmentalData: FC<StockEnvironmentalDataProps> = ({ environmentalData }) => {
    const { t } = useTranslations();
    const { power, electricRange, co2Combined, consumptionCombined } = environmentalData;

    const isConsumptionHidden =
        typeof Number(consumptionCombined.value) !== 'number' || Number(consumptionCombined.value) === 0;

    return (
        <>
            <div className="environmentalItem">
                <span>{t('technicalFeatures.environmentalDetails.engine.power')}</span>
                <div className="environmentalLabel">
                    {power.value}
                    {t('technicalFeatures.environmentalDetails.engine.power.label')}
                </div>
            </div>

            {isConsumptionHidden && electricRange.value ? (
                <div className="environmentalItem">
                    <span>{t(`technicalFeatures.environmentalDetails.consumption.electricRange`)}</span>
                    <div className="environmentalLabel">{t(`Distance`, { count: Number(electricRange.value) })}</div>
                </div>
            ) : (
                <div className="environmentalItem">
                    <span>{t(`technicalFeatures.environmentalDetails.consumption.mix`)}</span>
                    <div className="environmentalLabel">
                        {consumptionCombined.value}
                        {t(`technicalFeatures.environmentalDetails.consumption.mix.label`)}
                    </div>
                </div>
            )}
            <div className="environmentalItem">
                <span>{t(`technicalFeatures.environmentalDetails.consumption.co2`)}</span>
                <div className="environmentalLabel">
                    {co2Combined.value}
                    {t(`technicalFeatures.environmentalDetails.consumption.co2.label`)}
                </div>
            </div>
        </>
    );
};

export default StockEnvironmentalData;
